<template>
  <div class="container">
    <div class="product-list">
      <div class="list" v-for="(item,index) in collectList" :key="index" @click="goTaskDetail(item)">
        <!-- {{index}} -->
        <div class="product-img">
          <img :src="item.squarePicture" alt />
        </div>
        <div class="product-detail">
          <div class="pro-title">{{item.missionName}}</div>
          <div class="pro-text">
            <div class="pro-time">
              <div class>活动时间</div>
              <div class>起 {{item.missionStartTime}}</div>
              <div class>止 {{item.missionEndTime}}</div>
            </div>
          </div>
        </div>
        <div class="cancel" @click.stop="getCancelCollection(item.id)">取消收藏</div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from "../../api/config";
  export default {
    name: "collectList",
    props: ["region", "pageIndex", "pageSize", "lastId"],
    data() {
      return {
        collectList: [],
      };
    },
    created() {

      this.getCollectList();
    },
    methods: {
      // 收藏列表查询
      async getCollectList() {
        try {
          let data = {
            lastId: this.lastId,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
          }
          const res = await this.$http.getCollectionPage(data)
          // console.log(res.result.records)
          if (res.code == 200) {
            if (res.result) {
              res.result.records.forEach((item) => {
                item.squarePicture = item.squarePicture.indexOf("http") > -1 || item.squarePicture.indexOf(
                  "https") > -1 ? item.squarePicture : config.baseImgUrl + item.squarePicture
              })
              this.collectList = res.result.records;
              this.$parent.changePageInfo(res.result.current, res.result.size, res.result.total)
            } else {
              this.collectList = [];
            }
          } else {
            this.$message(res.message);
          }
        } catch (e) {
          throw e
        }
      },

      //取消收藏
      async getCancelCollection(id) {
        try {
          console.log(id)
          const res = await this.$http.cancelCollectionId(id)
          // console.log(res.result)
          if (res.code == 200) {
            this.getCollectList()
            this.$message.success(res.result);
          }

        } catch (e) {
          throw e
        }
      },
      // 跳转到任务详情页
      goTaskDetail(record) {
        // console.log(record)
        this.$router.push({
          path: "/task/taskDetail",
          query: {id:record.missionId},
        });
        // console.log('收藏跳转111111111111')
      },
    },

  }
</script>

<style scoped>
  .container {
    width: 100%;
  }

  .product-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    /* background-color: orange; */
  }

  .list {
    width: 194px;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 39px;
    /* background-color: red; */
  }

  .product-img {
    width: 100%;
  }

  .product-img img {
    width: 100%;
    height: 194px;
  }

  .product-detail {
    padding: 0 8px 15px 8px;
  }

  .pro-title {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 33px;
    color: #3A3A3A;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .pro-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .pro-time {
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 13px;
    color: #9E9E9E;
    margin: 12px 0 0 0;
  }

  .cancel {
    width: 100px;
    height: 35px;
    line-height: 35px;
    border: 1px solid #DFB876;
    font-weight: 500;
    font-size: 13px;
    border-radius: 18px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 18px;
    color: #DFB876;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/collectList/collectList.vue